// Single source of truth for legal page company details.
// EDIT THIS FILE to swap in your finalised legal entity name, address,
// contact emails, and effective date. Both Terms.jsx and Privacy.jsx
// (and any other legal surfaces) read from here -- update once, all
// pages stay in sync.
//
// Stripe activation verification reads these URLs to confirm the
// business is real, so the entity name + address + contact must match
// what you submitted to Stripe.

export const COMPANY = {
  // Legal entity that operates Pro Haul.
  legalName:     'Pro Haul LLC',

  // Public product / service name as shown to customers.
  productName:   'Pro Haul',

  // Mailing address shown in legal pages + included on Stripe-required
  // disclosures. Use the registered business address (NOT a home
  // address) -- a UPS Store box or registered agent works fine.
  address: {
    line1:   '10620 Southern Highlands Pkwy Ste 110',
    city:    'Las Vegas',
    state:   'NV',
    zip:     '89141',
    country: 'United States',
  },

  // Contact channels. support@prohaul.ai routes to a real inbox via
  // Resend; privacy@ can alias to the same inbox for now.
  supportEmail:  'support@prohaul.ai',
  privacyEmail:  'privacy@prohaul.ai',
  billingEmail:  'billing@prohaul.ai',

  // Governing law for the Terms (typically the state where the LLC is
  // organised). Nevada is the default given the operator's location.
  governingState: 'Nevada',
  governingVenue: 'Clark County, Nevada',

  // Public site URL (the legal pages reference back to this).
  siteUrl:       'https://app.prohaul.ai',

  // ISO date the current Terms / Privacy take effect. BUMP THIS every
  // time you publish a material revision -- the page renders it so
  // customers can see when policy last changed.
  effectiveDate: '2026-05-23',
};

// Formatted address line for inline rendering: "City, ST ZIP, Country".
// Returns just "City, ST" if zip is missing -- legal pages can use that
// without falling back to ugly comma-only output.
export const formatAddress = () => {
  const a = COMPANY.address;
  const cityState = `${a.city}, ${a.state}`;
  if (a.zip)   return `${a.line1 ? a.line1 + ', ' : ''}${cityState} ${a.zip}, ${a.country}`;
  if (a.line1) return `${a.line1}, ${cityState}, ${a.country}`;
  return `${cityState}, ${a.country}`;
};

export const formatEffectiveDate = () =>
  new Date(COMPANY.effectiveDate).toLocaleDateString('en-US', {
    year: 'numeric', month: 'long', day: 'numeric',
  });
